import {
  composeValidators,
  emailValidator,
  textMaxLengthValidator,
  textValidator,
  zipCodeValidator,
} from 'app/components/Form/utils/validators';
import SignUp from 'app/i18n/Signup';

export const SIGNUP_FORM_RULES = {
  firstName: {
    validate: composeValidators(
      textValidator('PROCURE_2009'),
      textMaxLengthValidator('PROCURE_2009', 30),
    ),
  },
  lastName: {
    validate: composeValidators(
      textValidator('PROCURE_2010'),
      textMaxLengthValidator('PROCURE_2010', 30),
    ),
  },
  password: {
    validate: textValidator('PROCURE_2006'),
  },
  email: {
    validate: composeValidators(
      textValidator('PROCURE_2001'),
      emailValidator('PROCURE_2002'),
    ),
  },
  primaryPhoneNumber: {
    validate: textValidator('PROCURE_14008'),
  },
  organization: {
    validate: composeValidators(
      textValidator(SignUp.FormValidations.Organization),
      textMaxLengthValidator(SignUp.FormValidations.Organization, 30),
    ),
  },
  address: {
    validate: textValidator('PROCURE_2018'),
  },
  city: {
    validate: textValidator('PROCURE_14004'),
  },
  state: {
    validate: textValidator('PROCURE_14005'),
  },
  website: {
    validate: textValidator('PROCURE_2011'),
  },
  zipCode: {
    validate: composeValidators(
      textValidator('PROCURE_2025'),
      zipCodeValidator('PROCURE_2012'),
    ),
  },
};
